<background-modal [isLoading]="submitStatus === 'loading'">
    <form *ngIf="submitStatus === 'normal'" [formGroup]="form" (ngSubmit)="registerSignedInUser()">
        <h1 i18n>Register now for {{camp?.name}}</h1>
        <p *ngIf="camp?.websiteUrl" i18n>Further information about the camp can be found on our <a [href]="camp?.websiteUrl" target="_blank" rel="noopener">website</a>.</p>

        <div *ngIf="!user">
            <h1 i18n>It looks like you are not signed in.</h1>
            <span i18n><a routerLink="/sign-in">Login</a> to your account</span>
            <span i18n>or <a routerLink="/register-user/{{camp?.campId}}">Register</a></span>
        </div>
        <ng-container *ngIf="user">
            <h2 i18n>you are loged in with: {{user.email}}</h2>

            <div class="row" *ngIf="participants.length > 1">
                <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="fill">
                      <mat-label i18n>Chose your Particioant</mat-label>
                      <mat-select formControlName="participantId">
                        <mat-option *ngFor="let participant of participants" [value]="participant.id">{{participant.firstName}} {{participant.lastName}}</mat-option>
                      </mat-select>
                      <mat-error i18n *ngIf="form.get('participantId')?.errors?.['required']">
                        Participant is required
                      </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row justify-content-end spacer">
                <div class="col-sm-12 col-md-3">
                    <button class="btn btn-primary" type="submit" [disabled]="!form.valid" i18n style="width: 100%;">
                        Register
                    </button>
                </div>
            </div>
        </ng-container>
    </form>
    <div class="row">
        <div *ngIf="submitStatus == 'success'" class="col-12">
            <h1 i18n>That worked</h1>
            <div>
                <span i18n>you will soon receive an Email. Please check your Spam folder.</span><br>
                <span i18n>If you didn't recived the Email, please contact</span> <a [href]="'mailto:freizeit@cjg-fn.de'" i18n i18n-href>freizeit&#64;cjg-fn.de</a>
            </div>
            <br><br>
            <div>
                <h2 i18n>important</h2>
                <p i18n>Please Check your personal information <a routerLink="/participant/update-personal-data">here</a></p>
                <span i18n>We do need some more information from you. Either you <a routerLink="/participant">login</a> now directly, or you do it later with the link in the Email.</span>
            </div>
        </div>
        <div *ngIf="submitStatus == 'error'" class="col-12">
            <h1 i18n>Something went wrong</h1>
            <h2 *ngIf="error">{{error}}</h2>
            <span i18n>Please try again later or contact an Administrator here:
            </span><a [href]="'mailto:info@cjg-fn.de'" i18n i18n-href>info&#64;cjg-fn.de</a>
        </div>
        <div *ngIf="submitStatus == 'disabled'" class="col-12">
            <h1 i18n>Registration Disabled</h1>
        </div>
    </div>
    <div class="row big-spacer">
        <div class="col-12">
            <span i18n>Login to a different account?</span>&nbsp;
            <a class="no_default" routerLink="/sign-in" i18n>Log In</a>
        </div>
    </div>
</background-modal>